import {
  type ThemeColorModes,
  setGlobalTheme,
  getGlobalTheme,
} from '@atlaskit/tokens';

interface CoreIFrameWindow extends Window {
  setTheme: (theme: string) => void;
}

export const getBrowserTheme = () => {
  if (
    window.matchMedia === undefined ||
    typeof window.matchMedia !== 'function'
  ) {
    return 'na';
  }

  const isDarkBrowserTheme =
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;

  return isDarkBrowserTheme ? 'dark' : 'light';
};

export const handleGlobalThemeChange = (theme: ThemeColorModes) => {
  const currentTheme = getGlobalTheme();
  setGlobalTheme({ ...currentTheme, colorMode: theme });

  // Manually update embedded core UI views
  const settingsFrame = document.getElementById(
    'settings-frame'
  ) as HTMLIFrameElement | null;
  const settingsFrameWindow: null | undefined | CoreIFrameWindow =
    settingsFrame?.contentWindow as CoreIFrameWindow;
  if (
    settingsFrameWindow &&
    typeof settingsFrameWindow.setTheme === 'function'
  ) {
    settingsFrameWindow.setTheme(theme);
  }
};

export const urls = {
  privacyPolicy: 'https://www.atlassian.com/legal/privacy-policy',
  atlassianResearchGroup: 'https://www.atlassian.com/research-group',
  contactSupportLink:
    'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues',
};
